import { render, staticRenderFns } from "./PaymentOrder.vue?vue&type=template&id=c56b4d74"
import script from "./PaymentOrder.vue?vue&type=script&lang=js"
export * from "./PaymentOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports